.root {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.75rem;
}

.instructions {
  margin-top: -0.25rem;
}

.tree {
  width: 100%;
  height: auto !important;
  min-width: 0;
  overflow: hidden;
  overflow-anchor: none;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-card);
}

.tree :global([role="tree"]) {
  min-height: unset;
  overflow: visible;
  background: transparent;
}

.tree :global([role="tree"] > *) {
  min-height: unset;
  overflow: visible;
}

.treeNode {
  min-height: 0 !important;
  padding-block: 0 !important;
  padding-inline-end: 0.75rem !important;
  border-radius: 0 !important;
  color: var(--color-foreground) !important;
  cursor: default !important;
  // Linked items (`#<tree>.<field>`) scroll to just below the top, like headings.
  scroll-margin-top: calc(var(--portal-topbar-height, 0px) + 2rem);
}

.treeNode:hover {
  background: transparent !important;
  color: var(--color-foreground) !important;
}

.treeNode .toggle {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: var(--radius-sm);
  color: var(--color-muted);
}

.treeNode .toggle:hover {
  background: var(--color-card-hover);
  color: var(--color-foreground);
}

.node,
.nodeContent {
  width: 100%;
  min-width: 0;
}

.fieldNode {
  width: 100%;
  min-width: 0;
  padding: 0.875rem 0;
  border-bottom: 1px solid var(--color-border);
}

.editableFieldNode {
  display: grid;
  grid-template-columns: minmax(12rem, 1fr) minmax(13rem, 0.8fr);
  align-items: center;
  gap: 1rem 1.5rem;
}

.fieldIdentity {
  min-width: 0;
}

.fieldHeading {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.5rem;
}

.fieldName {
  overflow-wrap: anywhere;
  font-size: 0.8125rem;
}

.enumValue {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  background: var(--color-surface-subtle);
  color: var(--color-muted);
}

.description {
  min-width: 0;
  margin-top: 0.4rem;
  color: var(--color-muted);
  font-family: var(--font-body-family);
  font-size: 0.8125rem;
  line-height: 1.5;
}

.description :global(p) {
  margin: 0;
  color: inherit;
  font: inherit;
}

.enumValues {
  display: flex;
  margin-top: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.5rem;
}

.enumList {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.enumValue {
  padding: 0.08rem 0.35rem;
  font-size: 0.6875rem;
}

.controlCell {
  min-width: 0;
}

.input,
.select {
  width: 100%;
  min-width: 0;
  font-family: var(--font-body-family);
  font-size: 0.875rem;
}

.unionOption,
.namedType {
  width: 100%;
  min-width: 0;
  padding-block: 0.75rem;
  border-bottom: 1px solid var(--color-border);
}

.unionOption {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 720px) {
  .editableFieldNode {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
  }

}
